import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { IApiResponse } from "../../../../utils/types/api-response";
import { fetchUpcomingSessions } from "../../services/upcoming-sessions.services";
import { IUpcomingSession } from "../../types/upcoming-sessions.types";

export function useFetchUpcomingSessions(
    sessionHistoryId?: string,
    enabled?: boolean
) {
    return useQuery<
        IApiResponse<IUpcomingSession[]>,
        AxiosError<IApiResponse<IUpcomingSession[]>>
    >({
        queryKey: ["upcoming-sessions", sessionHistoryId],
        queryFn: () => fetchUpcomingSessions(sessionHistoryId),
        enabled,
    });
}
